export const googleReviews = {"rating":"4.9","reviews":"126"}